const Mutations = Object.freeze({
	SET_SELECTED_INVENTORY_FORM:
		'inventoryFormModule/inventoryFormGrid/SET_SELECTED_INVENTORY_FORM',
	SET_GRID_VIEW: 'inventoryFormModule/inventoryFormGrid/SET_GRID_VIEW',
	SET_QUICK_FILTER: 'inventoryFormModule/inventoryFormGrid/SET_QUICK_FILTER',
	SET_ADVANCED_FILTER:
		'inventoryFormModule/inventoryFormGrid/SET_ADVANCED_FILTER',
	SET_SORTING: 'inventoryFormModule/inventoryFormGrid/SET_SORTING',
	SET_ROWS_PER_PAGE:
		'inventoryFormModule/inventoryFormGrid/SET_ROWS_PER_PAGE',
	SET_PAGE: 'inventoryFormModule/inventoryFormGrid/SET_PAGE',
	SET_COLUMNS: 'inventoryFormModule/inventoryFormGrid/SET_COLUMNS',
	SET_LOADING: 'inventoryFormModule/inventoryFormGrid/SET_LOADING',
	SET_GRID_DATA: 'inventoryFormModule/inventoryFormGrid/SET_GRID_DATA',
	SET_IRIS_USER_METADATA:
		'inventoryFormModule/inventoryFormGrid/SET_IRIS_USER_METADATA',
	SET_TOTAL_COUNT: 'inventoryFormModule/inventoryFormGrid/SET_TOTAL_COUNT',
});

export const Actions = Object.freeze({
	CLEAR: 'inventoryFormModule/inventoryFormGrid/CLEAR',
	LOAD_INVENTORY_FORM:
		'inventoryFormModule/inventoryFormGrid/LOAD_INVENTORY_FORM',
	LOAD_DEFAULT_GRID_VIEW_FOR_USER:
		'inventoryFormModule/inventoryFormGrid/LOAD_DEFAULT_GRID_VIEW_FOR_USER',
	LOAD_GRID_VIEW: 'inventoryFormModule/inventoryFormGrid/LOAD_GRID_VIEW',
	LOAD_GRID_DATA: 'inventoryFormModule/inventoryFormGrid/LOAD_GRID_DATA',
	APPLY_QUICK_FILTER:
		'inventoryFormModule/inventoryFormGrid/APPLY_QUICK_FILTER',
	APPLY_ADVANCED_FILTER:
		'inventoryFormModule/inventoryFormGrid/APPLY_ADVANCED_FILTER',
	CLEAR_ADVANCED_FILTER:
		'inventoryFormModule/inventoryFormGrid/CLEAR_ADVANCED_FILTER',
	UPDATE_ROWS_PER_PAGE:
		'inventoryFormModule/inventoryFormGrid/UPDATE_ROWS_PER_PAGE',
	UPDATE_PAGE: 'inventoryFormModule/inventoryFormGrid/UPDATE_PAGE',
	UPDATE_SORTING: 'inventoryFormModule/inventoryFormGrid/UPDATE_SORTING',
	UPDATE_QUICK_FILTER:
		'inventoryFormModule/inventoryFormGrid/UPDATE_QUICK_FILTER',
	UPDATE_ADVANCED_FILTER:
		'inventoryFormModule/inventoryFormGrid/UPDATE_ADVANCED_FILTER',
	UPDATE_GRID_VIEW_FIELDS:
		'inventoryFormModule/inventoryFormGrid/UPDATE_GRID_VIEW_FIELDS',
	SAVE_GRID_VIEW: 'inventoryFormModule/inventoryFormGrid/SAVE_GRID_VIEW',
	DELETE_GRID_VIEW: 'inventoryFormModule/inventoryFormGrid/DELETE_GRID_VIEW',
	SET_DEFAULT_GRID_VIEW:
		'inventoryFormModule/inventoryFormGrid/SET_DEFAULT_GRID_VIEW',

	EXPORT_CURRENT_PAGE:
		'inventoryFormModule/inventoryFormGrid/EXPORT_CURRENT_PAGE',
	EXPORT_ALL_DATA: 'inventoryFormModule/inventoryFormGrid/EXPORT_ALL_DATA',
	BULK_EDIT: 'inventoryFormModule/inventoryForm/BULK_EDIT',
});

export const Getters = Object.freeze({
	SELECTED_INVENTORY_FORM:
		'inventoryFormModule/inventoryFormGrid/SELECTED_INVENTORY_FORM',
	GRID_VIEW_NAME: 'inventoryFormModule/inventoryFormGrid/GRID_VIEW_NAME',
	GRID_VIEW: 'inventoryFormModule/inventoryFormGrid/GRID_VIEW',
	PAGE: 'inventoryFormModule/inventoryFormGrid/PAGE',
	ROWS_PER_PAGE: 'inventoryFormModule/inventoryFormGrid/ROWS_PER_PAGE',
	VISIBLE_COLUMNS: 'inventoryFormModule/inventoryFormGrid/VISIBLE_COLUMNS',
	HIDDEN_COLUMNS: 'inventoryFormModule/inventoryFormGrid/HIDDEN_COLUMNS',
	TOTAL_COUNT: 'inventoryFormModule/inventoryFormGrid/TOTAL_COUNT',
	GRID_DATA: 'inventoryFormModule/inventoryFormGrid/GRID_DATA',
	IRIS_USER_METADATA:
		'inventoryFormModule/inventoryFormGrid/IRIS_USER_METADATA',
	GRID_LOADING: 'inventoryFormModule/inventoryFormGrid/GRID_LOADING',
	SORTING: 'inventoryFormModule/inventoryFormGrid/SORTING',
	QUICK_FILTER: 'inventoryFormModule/inventoryFormGrid/QUICK_FILTER',
	ADVANCED_FILTER: 'inventoryFormModule/inventoryFormGrid/ADVANCED_FILTER',
	USER_GRIDS_VIEWS: 'inventoryFormModule/inventoryFormGrid/USER_GRIDS_VIEWS',
});

import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/inventoryFormService';
import { gridViewTypes } from '../../../../../enums/gridViewTypes';
import exportDataService from '../../../../../services/data/dataExportService';
import fileUtils from '../../../../../utils/fileUtils';
import { ExportMode } from '../../../../../enums/ExportMode';
import Snackbar from '../../../../../components/core/dialogs/snackbarMessage';

export default {
	state: {
		selectedInventoryform: null,
		gridView: null,
		quickFilter: { FieldId: null, Value: '' },
		advancedFilter: { Operator: 1, Filters: [], FiltersCount: 0 },
		sorting: [],
		rowsPerPage: 50,
		page: 1,
		columns: [],
		loading: false,
		gridData: [],
		irisUsersMetadata: [],
		totalCount: 0,
	},
	mutations: {
		[Mutations.SET_SELECTED_INVENTORY_FORM](state, item) {
			state.selectedInventoryform = item;
		},
		[Mutations.SET_GRID_VIEW](state, item) {
			state.gridView = item;
		},
		[Mutations.SET_QUICK_FILTER](state, item) {
			state.quickFilter = item;
		},
		[Mutations.SET_ADVANCED_FILTER](state, item) {
			state.advancedFilter = item;
			state.advancedFilter.FiltersCount = item.Filters.length;
		},
		[Mutations.SET_SORTING](state, item) {
			state.sorting = item;
		},
		[Mutations.SET_ROWS_PER_PAGE](state, value) {
			state.rowsPerPage = value;
		},
		[Mutations.SET_PAGE](state, value) {
			state.page = value;
		},
		[Mutations.SET_COLUMNS](state, items) {
			state.columns = items;
		},
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_GRID_DATA](state, items) {
			state.gridData = items;
		},
		[Mutations.SET_IRIS_USER_METADATA](state, items) {
			state.irisUsersMetadata = items;
		},
		[Mutations.SET_TOTAL_COUNT](state, value) {
			state.totalCount = value;
		},
	},
	actions: {
		[Actions.BULK_EDIT]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.bulkEdit(item)
					.then(() => {
						dispatch(Actions.LOAD_GRID_DATA);
						resolve(true);
					})
					.catch((error) => dispatch(GeneralActions.ERROR, error))
					.finally(() => dispatch(GeneralActions.LOADING, false));
			});
		},
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_GRID_DATA, null);
				commit(Mutations.SET_IRIS_USER_METADATA, []);
				commit(Mutations.SET_TOTAL_COUNT, 0);
				commit(Mutations.SET_PAGE, 1);
				commit(Mutations.SET_ROWS_PER_PAGE, 50);
				commit(Mutations.SET_LOADING, false);
				commit(Mutations.SET_SORTING, []);
				commit(Mutations.SET_ADVANCED_FILTER, {
					Operator: 1,
					Filters: [],
					FiltersCount: 0,
				});
				commit(Mutations.SET_QUICK_FILTER, {
					FieldId: null,
					Value: '',
				});
				commit(Mutations.SET_COLUMNS, []);
				commit(Mutations.SET_GRID_VIEW, null);
				commit(Mutations.SET_SELECTED_INVENTORY_FORM, null);
				resolve();
			});
		},
		[Actions.LOAD_INVENTORY_FORM]({ commit, dispatch }, itemId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getById(itemId)
					.then((resp) => {
						commit(
							Mutations.SET_SELECTED_INVENTORY_FORM,
							resp.data
						);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					});
			});
		},
		[Actions.LOAD_DEFAULT_GRID_VIEW_FOR_USER](
			{ commit, dispatch, state },
			userId
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				if (!state.selectedInventoryform) resolve(false);
				let entityId = state.selectedInventoryform.EntityId;
				let gridViews = state.selectedInventoryform.GridViews.filter(
					(gv) =>
						gv.EntityId == entityId &&
						gv.Type == gridViewTypes.InventoryForm
				);
				let userGridViews = gridViews.filter((x) => x.UserId == userId);
				let selectedGridView = null;
				if (userGridViews.length > 0) {
					selectedGridView = userGridViews.find(
						(x) => x.IsDefault === true
					);
				}
				if (selectedGridView == null) {
					selectedGridView = gridViews.find((x) => x.UserId == null);
				}
				commit(Mutations.SET_GRID_VIEW, selectedGridView);
				if (!selectedGridView) {
					commit(Mutations.SET_GRID_DATA, null);
					commit(Mutations.SET_TOTAL_COUNT, 0);
					commit(Mutations.SET_PAGE, 1);
					commit(Mutations.SET_ROWS_PER_PAGE, 50);
					commit(Mutations.SET_SORTING, []);
					commit(Mutations.SET_ADVANCED_FILTER, {
						Operator: 1,
						Filters: [],
					});
					commit(Mutations.SET_QUICK_FILTER, {
						FieldId: null,
						Value: '',
					});
					commit(Mutations.SET_COLUMNS, []);
					dispatch(GeneralActions.LOADING, false);
					resolve(false);
				}

				commit(Mutations.SET_PAGE, 1);
				commit(
					Mutations.SET_ROWS_PER_PAGE,
					selectedGridView.RowsPerPage
				);
				commit(Mutations.SET_SORTING, selectedGridView.Sorting);
				commit(Mutations.SET_QUICK_FILTER, {
					FieldId: null,
					Value: '',
				});
				commit(Mutations.SET_ADVANCED_FILTER, {
					Operator: selectedGridView.AdvancedFilterOperator,
					Filters: selectedGridView.AdvancedFilter,
				});
				commit(Mutations.SET_COLUMNS, selectedGridView.Columns);
				dispatch(GeneralActions.LOADING, false);
				dispatch(Actions.LOAD_GRID_DATA);
				resolve(true);
			});
		},
		[Actions.LOAD_GRID_VIEW]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_GRID_DATA, []);
				commit(Mutations.SET_GRID_VIEW, item);
				commit(Mutations.SET_ROWS_PER_PAGE, item.RowsPerPage);
				commit(Mutations.SET_PAGE, 1);
				commit(Mutations.SET_COLUMNS, item.Columns);
				commit(Mutations.SET_QUICK_FILTER, {
					FieldId: null,
					Value: '',
				});
				commit(Mutations.SET_ADVANCED_FILTER, {
					Operator: item.AdvancedFilterOperator || 1,
					Filters: item.AdvancedFilter || [],
				});
				commit(Mutations.SET_SORTING, item.Sorting || []);
				dispatch(GeneralActions.LOADING, false);
				dispatch(Actions.LOAD_GRID_DATA);
				resolve();
			});
		},
		[Actions.LOAD_GRID_DATA]({ commit, dispatch, state }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				let payload = {
					InventoryFormId: state.selectedInventoryform.Id,
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.map((x) => x.Id),
				};
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;
				dataService
					.loadGridViewData(payload)
					.then((resp) => {
						commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
						commit(Mutations.SET_GRID_DATA, resp.data.Data);
						commit(
							Mutations.SET_IRIS_USER_METADATA,
							resp.data.IrisUsers
						);
						commit(Mutations.SET_LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.UPDATE_PAGE]({ commit, dispatch }, value) {
			commit(Mutations.SET_PAGE, value);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_ROWS_PER_PAGE]({ commit, dispatch }, value) {
			commit(Mutations.SET_ROWS_PER_PAGE, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_SORTING]({ commit, dispatch }, value) {
			commit(Mutations.SET_SORTING, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_QUICK_FILTER]({ commit, dispatch }, value) {
			commit(Mutations.SET_QUICK_FILTER, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_ADVANCED_FILTER]({ commit, dispatch }, value) {
			commit(Mutations.SET_ADVANCED_FILTER, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_GRID_VIEW_FIELDS]({ commit, dispatch, state }, value) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let gridViewId = state.gridView.Id;
				let columns = value.map(({ Id, Order, IsVisible }) => ({
					Id,
					Order,
					IsVisible,
				}));
				dataService
					.updateColumns(gridViewId, columns)
					.then((resp) => {
						let gridView = resp.data;
						commit(Mutations.SET_GRID_VIEW, gridView);
						commit(Mutations.SET_COLUMNS, gridView.Columns);
						dispatch(GeneralActions.LOADING, false);
						dispatch(Actions.LOAD_GRID_DATA);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.SAVE_GRID_VIEW]({ commit, dispatch, state }, viewName) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let columns = state.columns.map(({ Id, Order }) => ({
					Id,
					Order,
				}));
				let gridView = {
					InventoryFormId: state.selectedInventoryform.Id,
					Name: viewName,
					RowsPerPage: state.rowsPerPage,
					EntityId: state.gridView.EntityId,
					Columns: columns,
					AdvancedFilter: state.advancedFilter,
					Sorting: state.sorting,
				};
				let gv = null;
				dataService
					.insertGridView(gridView)
					.then((resp) => {
						gv = resp.data;
						commit(Mutations.SET_GRID_VIEW, gv);
						commit(Mutations.SET_COLUMNS, gv.Columns);
						return dataService.getById(
							state.selectedInventoryform.Id
						);
					})
					.then((resp) => {
						commit(
							Mutations.SET_SELECTED_INVENTORY_FORM,
							resp.data
						);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.DELETE_GRID_VIEW]({ commit, dispatch, state }, view) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let reload = view.Id === state.gridView.Id;
				dataService
					.deleteGridView(view.Id, state.selectedInventoryform.Id)
					.then(() => {
						return dataService.getById(
							state.selectedInventoryform.Id
						);
					})
					.then((resp) => {
						commit(
							Mutations.SET_SELECTED_INVENTORY_FORM,
							resp.data
						);
						dispatch(GeneralActions.LOADING, false);
						if (reload) {
							dispatch(
								Actions.LOAD_DEFAULT_GRID_VIEW_FOR_USER,
								state.gridView.UserId
							);
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.SET_DEFAULT_GRID_VIEW]({ commit, dispatch, state }, view) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.setDefaultView(
						view.Id,
						state.selectedInventoryform.Id,
						view.IsDefault
					)
					.then(() => {
						return dataService.getById(
							state.selectedInventoryform.Id
						);
					})
					.then((resp) => {
						commit(
							Mutations.SET_SELECTED_INVENTORY_FORM,
							resp.data
						);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.EXPORT_CURRENT_PAGE](
			{ dispatch, state },
			{ timeZone, isDirectMode = ExportMode.DIRECT }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let payload = {
					InventoryFormId: state.selectedInventoryform.Id,
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.map((x) => x.Id),
					TimeZone: timeZone,
				};
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;

				// Choose export service based on export mode
				const exportService =
					isDirectMode === ExportMode.DIRECT
						? exportDataService.downloadInventoryFormDirect
						: exportDataService.downloadInventoryForm;

				exportService(payload)
					.then((resp) => {
						if (isDirectMode === ExportMode.DIRECT) {
							// Direct export - download immediately
							const fileInfo =
								fileUtils.extractFileInfoFromResponse(resp);
							const blob = new Blob([resp.data], {
								type: fileInfo.mimeType,
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', fileInfo.filename);
							document.body.appendChild(link);
							link.click();

							// Resource cleanup
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);
						} else {
							// Background export - show notification
							Snackbar({
								message:
									'Export request registered. You will receive a notification when the file is ready for download!',
								timeout: 5000,
							});
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.EXPORT_ALL_DATA](
			{ dispatch, state },
			{ timeZone, isDirectMode = ExportMode.DIRECT }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let payload = {
					InventoryFormId: state.selectedInventoryform.Id,
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.totalCount,
					Page: 1,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.map((x) => x.Id),
					TimeZone: timeZone,
				};
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;

				// Choose export service based on export mode
				const exportService =
					isDirectMode === ExportMode.DIRECT
						? exportDataService.downloadInventoryFormDirect
						: exportDataService.downloadInventoryForm;

				exportService(payload)
					.then((resp) => {
						if (isDirectMode === ExportMode.DIRECT) {
							// Direct export - download immediately
							const fileInfo =
								fileUtils.extractFileInfoFromResponse(resp);
							const blob = new Blob([resp.data], {
								type: fileInfo.mimeType,
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', fileInfo.filename);
							document.body.appendChild(link);
							link.click();

							// Clean up resources
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);
						} else {
							// Background export - show notification
							Snackbar({
								message:
									'Export request registered. You will receive a notification when the file is ready for download!',
								timeout: 5000,
							});
						}
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.SELECTED_INVENTORY_FORM]: (state) => {
			if (!state.selectedInventoryform) return null;
			return state.selectedInventoryform;
		},

		[Getters.GRID_VIEW_NAME]: (state) => {
			if (!state.gridView) return '';
			return state.gridView.Name || '';
		},

		[Getters.GRID_VIEW]: (state) => {
			if (!state.gridView) return null;
			return JSON.parse(JSON.stringify(state.gridView));
		},

		[Getters.PAGE]: (state) => {
			return state.page;
		},
		[Getters.ROWS_PER_PAGE]: (state) => {
			return state.rowsPerPage;
		},
		[Getters.VISIBLE_COLUMNS]: (state) => {
			if (!state.columns) return [];
			let visibleColumns = state.columns
				.filter((x) => x.IsVisible === true)
				.sort((a, b) => a.Order - b.Order);
			return JSON.parse(JSON.stringify(visibleColumns));
		},
		[Getters.HIDDEN_COLUMNS]: (state) => {
			if (!state.columns) return [];
			let hiddenColumns = state.columns
				.filter((x) => x.IsVisible === false)
				.sort((a, b) => a.Order - b.Order);
			return JSON.parse(JSON.stringify(hiddenColumns));
		},
		[Getters.TOTAL_COUNT]: (state) => {
			return state.totalCount;
		},
		[Getters.GRID_DATA]: (state) => {
			if (!state.gridData) return [];
			return JSON.parse(JSON.stringify(state.gridData));
		},
		[Getters.SORTING]: (state) => {
			return JSON.parse(JSON.stringify(state.sorting));
		},
		[Getters.GRID_LOADING]: (state) => {
			return state.loading;
		},
		[Getters.QUICK_FILTER]: (state) => {
			return JSON.parse(JSON.stringify(state.quickFilter));
		},
		[Getters.ADVANCED_FILTER]: (state) => {
			return JSON.parse(JSON.stringify(state.advancedFilter));
		},
		[Getters.USER_GRIDS_VIEWS]: (state) => {
			if (!state.selectedInventoryform) return [];
			if (!state.selectedInventoryform.GridViews) return [];
			// let gv = state.selectedInventoryform.GridViews.filter(x => x != null && x.UserId != null && x.EntityId == state.selectedInventoryform.EntityId && x.Type == gridViewTypes.InventoryForm);
			let gv = state.selectedInventoryform.GridViews.filter(
				(x) =>
					x != null &&
					x.EntityId == state.selectedInventoryform.EntityId &&
					x.Type == gridViewTypes.InventoryForm
			);
			if (!gv) return [];
			return JSON.parse(JSON.stringify(gv));
		},
		[Getters.IRIS_USER_METADATA]: (state) => {
			if (!state.irisUsersMetadata) return [];
			return JSON.parse(JSON.stringify(state.irisUsersMetadata));
		},
	},
};
